export enum EFormFieldWatcherActions {
    clear = 'clear', // очистить поле
    disable = 'disable', // сделать поле disabled
    hide = 'hide', // скрыть поле
    require = 'require', // сделать поле обязательным
    setOwnValue = 'setOwnValue', // установить значение поля, на котором стоит watcher (собственное значение)
    validate = 'validate', // провалидировать поле
    allowEmpty = 'allowEmpty', // сделать необязательным
    addValidationRules = 'addValidationRules', // добавить правило валидации
    addFieldError = 'addFieldError', // добавить кастомную ошибку на срабатываемое событие
    enableField = 'enableField', // убрать флажок отключен
    disableDate = 'disableDate', // дизейблит даты вне диапазона (dateRange) в DateCell

    fetchDataToCustomSelect = 'fetchDataToCustomSelect'
}

export enum EFormFieldWatcherConnective {
    OR = 'OR',
    AND = 'AND',
    NOT = 'NOT',
    AND_NOT = 'AND_NOT',
    OR_NOT = 'OR_NOT'
}

export enum EFormFieldWatcherConditions {
    hasRole = 'hasRole',
    formEditing = 'formEditing', // если поле с watcher'ом в модальном окне с редактированием записи
    formCreating = 'formCreating', // если поле с watcher'ом в модальном окне с созданием записи
    unset = 'unset', // если target-поле имеет falsy-значение (false, undefined, null, "", 0 и т.д.)
    set = 'set', // если target-поле не falsy
    equals = 'equals', // если собственное значение поля равно значению target-поля
    fieldEqualsToValue = 'fieldEqualsToValue',
    fieldEqualsToValues = 'fieldEqualsToValues',
    compareFieldValues = 'compareFieldValues',
    /*
      fieldEqualsToValue = если значение по ключу в target-поле равно "withValue"
    */
    equalsToValue = 'equalsToValue', // если значение в target-поле равно "withValue"
    notEqualsToValue = 'notEqualsToValue', // если значение в target-поле НЕ равно "withValue"
    equalsByKeyOrToValue = 'equalsByKeyOrToValue', /*
        попытаться сравнить по "fieldEqualsToValue", при неудаче сравнить по "equalsToValue"
    */

    refererenceValueHasBeenChanged = 'refererenceValueHasBeenChanged',
    isFieldSet = 'isFieldSet',
    always = 'always',
    unique = 'unique',
}

export enum ESameDateUnits {
    sameMonth = 'sameMonth',
    sameDay = 'sameDay',
    sameYear = 'sameYear'
}
